export default __webpack_public_path__ + "static/media/add ons.aa00fb68.png";